module.exports = __webpack_public_path__ + "img/BlueShape.c66d51fa.png";